import { canEditTotem } from './totemPermissions'
import type { PlacedTotem } from '../hooks/useTotemSlots'
import type { TotemDisplay } from '../components/MemberInterestList'

/** The set-card / set-dialog row shape for a placed totem, with the viewer's
 *  edit right resolved from the totem's editor list. */
export function toTotemDisplay(p: PlacedTotem, currentUserId: string | null | undefined): TotemDisplay {
  return {
    emoji: p.totem.emoji,
    name: p.totem.name,
    imageUrl: p.totem.imageUrl,
    borderStyle: p.totem.borderStyle,
    partialRange: p.slot.partialRange,
    groupId: p.slot.groupId,
    totemId: p.slot.totemId,
    canEdit: canEditTotem(p.totem, p.group, currentUserId),
  }
}
